import React from 'react';
import { Stethoscope, Briefcase, Scale, MapPin, Heart, Building } from 'lucide-react';

const Industries = () => {
  const industries = [
    {
      icon: Stethoscope,
      title: 'Doctors & Healthcare',
      description: 'Patient acquisition campaigns and reputation management for medical practitioners.',
      image: 'https://images.unsplash.com/photo-1638202993928-7267aad84c31',
      stats: '150+ Healthcare Clients'
    },
    {
      icon: Stethoscope,
      title: 'Dental Practices',
      description: 'Specialized marketing strategies to grow your dental practice and attract new patients.',
      image: 'https://images.pexels.com/photos/3845736/pexels-photo-3845736.jpeg',
      stats: '80+ Dental Clinics'
    },
    {
      icon: Scale,
      title: 'Legal Professionals',
      description: 'Professional branding and lead generation for advocates and law firms.',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2',
      stats: '50+ Legal Firms'
    },
    {
      icon: MapPin,
      title: 'Immigration Consultants',
      description: 'Targeted campaigns to connect with clients seeking immigration services.',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7',
      stats: '40+ Consultants'
    },
    {
      icon: Heart,
      title: 'Wedding Planners',
      description: 'Creative content and social media strategies to showcase your wedding services.',
      image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d',
      stats: '30+ Planners'
    },
    {
      icon: Building,
      title: 'Professional Services',
      description: 'Comprehensive digital marketing for consultants, coaches, and service providers.',
      image: 'https://images.pexels.com/photos/11329815/pexels-photo-11329815.jpeg',
      stats: '100+ Businesses'
    }
  ];

  return (
    <section id="industries" className="py-24" style={{ backgroundColor: '#e6e67c' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Industries We Serve</span>
          <h2 className="mt-2 text-4xl lg:text-5xl font-bold text-gray-900" style={{ fontFamily: 'var(--font-serif)' }}>
            Specialized Marketing for Your Profession
          </h2>
          <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
            We understand the unique marketing needs of different professions and create tailored strategies that deliver results.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry, index) => {
            const IconComponent = industry.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                {/* Industry Image */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  
                  {/* Icon Overlay */}
                  <div className="absolute top-4 right-4">
                    <div className="w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-black" />
                    </div>
                  </div>

                  {/* Stats Badge */}
                  <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm rounded-full px-4 py-2">
                    <span className="text-sm font-semibold text-gray-900">{industry.stats}</span>
                  </div>
                </div>

                {/* Industry Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'var(--font-serif)' }}>
                    {industry.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {industry.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            Don't see your profession listed? We work with businesses across all industries.
          </p>
          <button className="bg-black text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors duration-200">
            Discuss Your Industry Needs
          </button>
        </div>
      </div>
    </section>
  );
};

export default Industries;
